//
// Imports
//

import * as BrowserUtilities from "@donutteam/browser-utilities";

import { RequestBody, ResponseBodySchema } from "../../../../api/routes/v6/forum-board-preferences/update.schemas.js";

//
// Component
//

export function initialiseForumBoardPreferencesForm(forumBoardPreferencesForm: HTMLFormElement)
{
	const apiUrl = BrowserUtilities.ElementClientLib.getStringDataOrThrow(forumBoardPreferencesForm, "apiUrl");

	const inputs = forumBoardPreferencesForm.querySelectorAll("input[type=checkbox]") as NodeListOf<HTMLInputElement>;
	
	forumBoardPreferencesForm.addEventListener("submit",
		(event) =>
		{
			event.preventDefault();
		});

	for (const input of inputs)
	{
		const components = input.name.split("_");

		const forumBoard_id = parseInt(components[1] ?? "");

		if (isNaN(forumBoard_id))
		{
			throw new Error("[ForumBoardPreferencesForm] Invalid forum board ID: " + components[1]);
		}

		input.addEventListener("change",
			async () =>
			{
				const originalState = !input.checked;

				try
				{
					input.disabled = true;

					const requestBody: RequestBody =
					{
						forumBoard_id,
						enabled: input.checked,
					};

					const response = await fetch(apiUrl + "/v6/forum-board-preferences/update",
						{
							credentials: "include",
							method: "POST",
							headers:
							{
								"Content-Type": "application/json",
							},
							body: JSON.stringify(requestBody),
						});

					const responseJson = await response.json();

					const responseBody = ResponseBodySchema.parse(responseJson);

					if (!responseBody.success)
					{
						throw new Error(responseBody.errors[0]?.message ?? "Unknown error.");
					}
				}
				catch (error)
				{
					console.error("[ForumBoardPreferencesForm] Error updating forum board preference:", error);

					input.checked = originalState;
				}
				finally
				{
					input.disabled = false;
				}
			});
	}

	forumBoardPreferencesForm.classList.add("initialised");
}

export function initialiseForumBoardPreferencesForms()
{
	const forumBoardPreferencesForms = document.querySelectorAll<HTMLFormElement>(".component-forum-board-preferences-form:not(.initialised)");

	console.log("[ForumBoardPreferencesForm] Initialising " + forumBoardPreferencesForms.length + " instances...");

	for (const forumBoardPreferencesForm of forumBoardPreferencesForms)
	{
		try
		{
			initialiseForumBoardPreferencesForm(forumBoardPreferencesForm);
		}
		catch (error)
		{
			console.error("[ForumBoardPreferencesForm] Error initialising:", forumBoardPreferencesForm, error);
		}
	}
}